<script>
  export default {
    name: 'btn-novo-valor-lance-confirmar',
    data () {
      return {
        buttonClosed: false,
        opened: false,
        novoValor: null,
        lance: null
      }
    },
    methods: {
      closeButtonConfig () {
        this.buttonClosed = true
      },
      open (lance, novoValor, cb) {
        this.opened = true
        this.novoValor = novoValor
        this.lance = lance
        this.cb = cb
        this.$nextTick(() => {
          this.$refs.btn.focus()
        })
      },
      close () {
        this.opened = false
      },
      confirm () {
        this.cb(this.novoValor)
        this.close()
      }
    }
  }
</script>

<template>
  <div>
    <div class="u-bg-overlay" v-if="opened"></div>
    <div class="u-theme-config-container" :class="{'is-closed': opened}">

      <div class="u-theme-config-panel" :class="{'open': opened}">

        <div v-if="opened" class="u-theme-content">

          Tem certeza que deseja alterar o valor?<br><br>

          De <span class="label text-sm bg-black">R$ {{lance.valor | moeda}}</span>
          para <span class="label text-sm bg-black">R$ {{novoValor | moeda}}</span>
          <p class="m-t-xl">
            <button ref="btn" tabindex="1" @click="confirm()" class="btn btn-success">Confirmar</button>
            <button tabindex="1" @click="close()" class="btn btn-default">Cancelar</button>
          </p>

        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ConfirmAlteracaoValorLance.vue?efda89f2